module.exports = __webpack_public_path__ + "static/media/man.298164f4.png";